import { CoreService } from 'src/app/core/services/core.service';
import { Component, OnInit } from '@angular/core';
import {
  Router,
  RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { UN_AUTHORIZED_URL } from './shared/constants/constant';
import { AuthService } from './core/services/auth.service';
import { MasterService } from './shared/service/master.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loading = true;
  loggedIn = false;
  loginFail = false;

  constructor(
    private router: Router,
    private coreService: CoreService,
    private authService: AuthService,
    private masterService: MasterService,
  ) {
    this.router.events.subscribe((e: RouterEvent) => {
      this.navigationInterseptor(e);
    });
  }

  navigationInterseptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }

    if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    ) {
      this.loading = false;
    }
  }

  ngOnInit() {
    this.authService.authenticated$.subscribe(() => {
      this.getProfile();
    });
  }

  /**
   * used to get logged user details
   */
  public getProfile(): void {
    this.masterService
      .getUserDetailsByGUID(this.authService.activeAccount.localAccountId)
      .subscribe(
        (user: any) => {
          this.loggedIn = true;
          this.coreService.setLoggedInUserDetails(user[0]);
        },
        (err: any) => {
          this.loginFail = true;
          this.loading = false;
          this.router.navigateByUrl(UN_AUTHORIZED_URL);
        },
      );
  }
}
